import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BuNameService } from '../../../helper/core/bu-name.service';
import { CoreService } from '../../../helper/core/core.service';
import { Event } from "../model/event.model";
import { environment } from '../../../../environments/environment';

@Injectable()
export class EventService {

  initialDataForm: any = {
    id: null,
    step: 1,
    validStep: 1,
    region: [],
    ville: [],
    lieu: [],
    dates: null,
    chosenDateId: null,
    idRegistration: null,
    dataVirtualEvents: null,
    dataSlot: null,
    registerForm: null,
    remainingPlaces: null,
    modalOpen: false,
    axeHasCommercialEvents: true,
    commentary: null,
  }

  dataForm: any = {
    id: null,
    step: 1,
    validStep: 1,
    region: [],
    ville: [],
    lieu: [],
    dates: null,
    chosenDateId: null,
    idRegistration: null,
    dataVirtualEvents: null,
    dataSlot: null,
    registerForm: null,
    remainingPlaces: null,
    modalOpen: false,
    axeHasCommercialEvents: true,
    commentary: null,
  }

  event: Event = null;
  constructor(private core: CoreService, private buName: BuNameService,
    private meta: Meta,
    private route: ActivatedRoute,
    private router: Router) {
    router.events.subscribe(route => {
      if (route instanceof NavigationEnd && route.url === "/ateliersnumeriques") {
        this.dataForm = this.initialDataForm;
      }
    })
  }

  cleanHTML(str) {
    if ((str === null) || (str === '') || (str == undefined)) {
      return false;
    }
    else {
      str = str.toString();
      return str.replace(/<[^>]*>/g, '');
    }
  }

  getEventInformations = (eventSlug: string): Promise<void> => {
    return new Promise((resolve, reject) => {
      this.core.getEvent(eventSlug).subscribe((event: Event) => {
        this.event = event;
        this.meta.removeTag('name="og:title"');
        this.meta.removeTag('name="og:description"');
        this.meta.removeTag('name="og:image"');
        this.meta.removeTag('name="og:type"');
        this.meta.addTags([
          { name: 'og:title', content: event.name },
          { name: 'og:description', content: this.cleanHTML(event.shortDescription) },
          { name: 'og:image', content: `${event.image}` },
          { name: 'og:type', content: 'article' },
        ]);

        this.setBuNameInformations();
        if (event.virtual) {
          this.dataForm = { ...this.dataForm, dates: event.dates }
        }
        resolve();
      });
    });
  }
    setBuNameInformations = () => {
      this.buName.name = this.event.buName;
      this.buName.url = this.event.buSlug;
      this.buName.img = (typeof this.event.buLogo != "undefined") ? this.event.buLogo : "default";
      this.buName.title = this.event.name;
    }

    changeStep = (stepNumber: number) => {
      // On change l'étape seulement sur les étapes déjà validées.
      if (this.dataForm.validStep >= stepNumber) {
        this.dataForm.step = stepNumber;
      }
    }

    renderClassStep = () => {
      switch (this.dataForm.step) {
        case 1:
          return 'event_item_steps first';
        case 2:
          return 'event_item_steps second'
        case 3:
          return 'event_item_steps third'
        case 4:
          return 'event_item_steps fourth'
        default:
          break;
      }
    }
  }



// WEBPACK FOOTER //
// ./src/app/screens/register-event/controller/event.service.ts